import { Menu, MenuProps } from 'antd';
import { ROUTES } from 'constants/common';

import { LogoLink } from '../logo-link';
import { SideNavFooter } from '../side-nav-footer';

import './side-nav-content.less';

interface SideNavContentProps {
  collapsed: boolean;
  menuProps: MenuProps;
  baseLogoUrl?: string;
  secondLogoUrl?: string;
  shouldHideFooterLogo?: boolean;
}

export const SideNavContent = ({
  collapsed,
  menuProps,
  baseLogoUrl,
  secondLogoUrl,
  shouldHideFooterLogo,
}: SideNavContentProps) => (
  <div className="side-nav-content">
    <LogoLink
      to={ROUTES.HOME}
      collapsed={collapsed}
      baseLogoUrl={baseLogoUrl}
      secondLogoUrl={secondLogoUrl}
    />
    <Menu data-testid="nav-menu" theme="dark" mode="inline" {...menuProps} />
    {baseLogoUrl && !shouldHideFooterLogo && <SideNavFooter collapsed={collapsed} />}
  </div>
);
